import axios from '@/libs/api.request'
import config from '@/config'

const privateCloudBaseUrl = config.basePrivateCloudUrl + '/cloud/api/v1/'

export const getPrivateCloudAggregate = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'aggregate/',
    params: params,
    defaultTenant: true,
    method: 'get'
  })
}

export const detailPrivateCloudAggregate = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'aggregate/',
    method: 'get'
  })
}

export const editPrivateCloudAggregate = (data, id) => {
  let url = `${privateCloudBaseUrl}aggregate/`
  let method = 'post'
  if (id) {
    url += `${id}/`
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    defaultTenant: true,
    method: method
  })
}

export const deletePrivateCloudAggregate = (id) => {
  return axios.request({
    url: `${privateCloudBaseUrl}aggregate/${id}/`,
    defaultTenant: true,
    method: 'delete'
  })
}

export const execPrivateCloudAggregateAction = (data, id) => {
  return axios.request({
    url: `${privateCloudBaseUrl}aggregate/${id}/exec_action/`,
    data: data,
    method: 'post'
  })
}

export const updatePrivateCloudAggregateHosts = (data, id) => {
  return axios.request({
    url: `${privateCloudBaseUrl}aggregate/${id}/hosts/`,
    data: data,
    defaultTenant: true,
    method: 'put'
  })
}
